import Head from 'next/head'
import { ReactNode } from 'react'
export const SEOConfig = {
  title: `EchoTik - TikTok Shop Sellers must-have analytics Tool`,
  keywords: `TikTok Shop Seller, Data Analytics, Influencer`,
  description: `EchoTik is a TikTok shop data analytics platform that helps sellers or influencers find out goods, videos, music`
}

interface Prop {
  title?: string
  description?: string
  keywords?: string
  extra?: ReactNode
}
export function SEOHeader({
  title = SEOConfig.title,
  description = SEOConfig.description,
  keywords = SEOConfig.keywords,
  extra = null
}: Prop) {
  return (
    <Head>
      <meta charSet="UTF-8" />
      <link rel="shortcut icon" type="image/x-icon" href="/icon.ico" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta httpEquiv="X-UA-Compatible" content="ie=edge" />
      <title>{title}</title>
      <meta name="keywords" content={keywords} />
      <meta name="description" content={description} />
      {extra}
    </Head>
  )
}
